import cx from 'classnames';
import React from 'react';

import Form from './Form';

import { useLocationContext } from '../../context/LocationContext';
import Location from '../LocationDisplay/Location';
import LocationWrapper from '../LocationDisplay/LocationWrapper';

type Props = {
  formHeading?: string;
};

export default function LocationInputForm({ formHeading }: Props) {
  const { isDeliveryAllowed = true } = useLocationContext();

  return (
    <div
      data-qa="form-wrapper"
      data-testid="form-wrapper"
      className={cx(
        'flex flex-col items-center border-0 border-b border-solid border-grey-2 bg-grey-1 px-24 pb-32',
        {
          'pt-32': !isDeliveryAllowed,
          'pb-48': !isDeliveryAllowed,
          's:max-m:h-full': !isDeliveryAllowed
        }
      )}
    >
      <p
        data-qa="form-heading"
        data-testid="form-heading"
        className={cx('m-0 pt-8 text-center text-grey-5 tl-body-m', {
          'w-[257px]': !isDeliveryAllowed
        })}
      >
        {formHeading}
      </p>
      <Form />
      <LocationWrapper>
        <Location />
      </LocationWrapper>
    </div>
  );
}
